"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8497],{

/***/ 78796:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/auth-bg.2d8c7831.jpg","height":1920,"width":1560,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAbEAACAwADAAAAAAAAAAAAAAABAgADEQRCUf/EABUBAQEAAAAAAAAAAAAAAAAAAAQG/8QAGREAAwADAAAAAAAAAAAAAAAAAAECEVGx/9oADAMBAAIRAxEAPwCPetC1tJ4zVPVh09gfIiIYsZp1lvb6f//Z","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 84670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Download; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55537);




var Download = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_1__/* .IconBox */ .zb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M35.2745 33.5934L35.2746 6.00005L29.4564 6.00006L29.4563 33.5935L17.3452 21.4822L13.2311 25.5963L32.3653 44.7308L51.4998 25.5964L47.3857 21.4823L35.2745 33.5934Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "5",
                y: "51",
                width: "54",
                height: "7"
            })
        ]
    }));
};


/***/ }),

/***/ 19838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ File; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55537);




var File = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_summer_jst_react_icon__WEBPACK_IMPORTED_MODULE_1__/* .IconBox */ .zb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M35.5 0H9V64H55V19.6009C55.0017 19.5674 55.0025 19.5338 55.0025 19.5C55.0025 19.4662 55.0017 19.4326 55 19.3991V18.6716L54.4751 18.1467C54.4371 18.1053 54.3973 18.0655 54.3559 18.0274L36.3293 0H35.5ZM33.5 4H13V60H51V21.5H33.5V4ZM48.1717 17.5H37.5V6.82774L48.1717 17.5Z"
        })
    }));
};


/***/ }),

/***/ 95139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79017);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73098);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71008);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78296);
/* harmony import */ var src_assets_images_auth_bg_jpg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78796);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68251);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-bottom: -50px;\n  ",
        " {\n    margin-bottom: 0;\n    min-height: calc(\n      100vh - var(--header-static-height) - var(--header-fixed-height)\n    );\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: 50%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: max-content;\n  margin: 0 auto;\n  padding: 30px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  font-size: 24px;\n  line-height: 110%;\n  color: ",
        ";\n  ",
        " {\n    font-size: 36px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 16px 0 32px;\n  ",
        " {\n    font-size: 16px;\n    margin: 20px 0 40px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 370px;\n  clip-path: polygon(0 0, 100% 0, 100% 100%, 15% 100%);\n  ",
        " {\n    position: absolute;\n    bottom: 0;\n    top: 0;\n    right: 0;\n    width: 50%;\n    height: calc(100% + var(--footer-static-height));\n  }\n  ",
        " {\n    right: auto;\n    left: 0;\n    transform: scaleX(-1);\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 158px !important;\n  ",
        " {\n    min-width: 264px !important;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}











var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].section.withConfig({
    displayName: "not-found__Wrapper",
    componentId: "sc-4a2fb9e1-0"
})(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "not-found__ContentWrapper",
    componentId: "sc-4a2fb9e1-1"
})(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "not-found__Content",
    componentId: "sc-4a2fb9e1-2"
})(_templateObject2());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].h1.withConfig({
    displayName: "not-found__Title",
    componentId: "sc-4a2fb9e1-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.palette.neauvia;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Description = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].p.withConfig({
    displayName: "not-found__Description",
    componentId: "sc-4a2fb9e1-4"
})(_templateObject4(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "not-found__ImageContainer",
    componentId: "sc-4a2fb9e1-5"
})(_templateObject5(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, src_styles_theme__WEBPACK_IMPORTED_MODULE_9__/* .dirRTL */ .gX);
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .zx).attrs({
    forwardedAs: "a"
}).withConfig({
    displayName: "not-found__StyledButton",
    componentId: "sc-4a2fb9e1-6"
})(_templateObject6(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var NotFoundPage = function() {
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_11__.useTranslate)()._;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_6__/* .ConstraintContainer */ .a, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Content, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                                children: _("404 Page not found")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Description, {
                                children: _("Page you were looking for was not found.")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_3__/* .TrackedLink */ .A, {
                                href: "/",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                                    children: _("Go to main page")
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: src_assets_images_auth_bg_jpg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                    layout: "fill",
                    objectFit: "cover"
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);


/***/ }),

/***/ 38497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _code_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/pages/not-found.tsx
var not_found = __webpack_require__(95139);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/models/pim/index.ts
var pim = __webpack_require__(82445);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
// EXTERNAL MODULE: ./src/components/common/PimImage.tsx
var PimImage = __webpack_require__(43573);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(72873);
// EXTERNAL MODULE: ./src/utils/casePathEmptyString.ts
var casePathEmptyString = __webpack_require__(12732);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(10763);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageShowcase/ProductPageShowcaseGallery.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 12px;\n\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 77px;\n\n  .swiper-slide {\n    width: 77px;\n    height: 77px;\n    margin-right: 8px;\n  }\n\n  ",
        " {\n    width: 87px;\n    height: 410px;\n\n    .swiper-slide {\n      width: 87px;\n      height: 87px;\n      margin-bottom: 8px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    &::after {\n      transform: scaleX(1);\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  overflow: hidden;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3rpx;\n    background: ",
        ";\n    transition: 0.25s;\n    transform-origin: 0% 50%;\n    transform: scaleX(0);\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 335px;\n  height: 335px;\n\n  ",
        " {\n    width: 430px;\n    height: 430px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageShowcaseGallery__Container",
    componentId: "sc-e6fe34e6-0"
})(_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ThumbnailsSwiper = (0,styled_components_browser_esm["default"])(swiper_react/* Swiper */.t).withConfig({
    displayName: "ProductPageShowcaseGallery__ThumbnailsSwiper",
    componentId: "sc-e6fe34e6-1"
})(_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Thumnbail = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageShowcaseGallery__Thumnbail",
    componentId: "sc-e6fe34e6-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.palette.accent;
}, (0,casePathEmptyString/* casePathEmptyString */.Q)("$active")((0,styled_components_browser_esm.css)(_templateObject2())));
var SwiperContainer = (0,styled_components_browser_esm["default"])(swiper_react/* Swiper */.t).withConfig({
    displayName: "ProductPageShowcaseGallery__SwiperContainer",
    componentId: "sc-e6fe34e6-3"
})(_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageShowcaseGallery = function(product) {
    var ref = (0,react.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var ref1 = (0,react.useState)(null), thumbnailSwiper = ref1[0], setThumbnailSwiper = ref1[1];
    var isDesktop = (0,useMediaQuery/* useMediaQuery */.a)(designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
    var ref2 = (0,react.useState)(0), activeIndex = ref2[0], setActiveIndex = ref2[1];
    var images = product.image ? [
        product.image
    ] : [];
    (0,react.useEffect)(function() {
        if (swiper && thumbnailSwiper) {
            swiper.slideTo(activeIndex);
            thumbnailSwiper.slideTo(activeIndex);
        }
    }, [
        swiper,
        thumbnailSwiper,
        activeIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            images.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailsSwiper, {
                direction: isDesktop ? "vertical" : "horizontal",
                slidesPerView: "auto",
                onSwiper: setThumbnailSwiper,
                onSlideChange: function(s) {
                    return setActiveIndex(s.activeIndex);
                },
                children: images === null || images === void 0 ? void 0 : images.map(function(image, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                        onClick: function() {
                            return setActiveIndex(i);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumnbail, {
                            $active: activeIndex === i,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                                src: image.id,
                                layout: "fill",
                                objectFit: "contain"
                            })
                        })
                    }, image.id + i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperContainer, {
                slidesPerView: 1,
                onSwiper: setSwiper,
                onSlideChange: function(s) {
                    return setActiveIndex(s.activeIndex);
                },
                children: images === null || images === void 0 ? void 0 : images.map(function(image, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                            src: image.id,
                            layout: "fill",
                            objectFit: "contain",
                            sizes: "100vw"
                        })
                    }, image.id + i);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/common/Heading.tsx
var Heading = __webpack_require__(79557);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
// EXTERNAL MODULE: ./src/components/common/typography/Text.tsx
var Text = __webpack_require__(51306);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@summer/jst-react-icon/lib/index.js
var lib = __webpack_require__(55537);
;// CONCATENATED MODULE: ./src/components/icons/FDA.tsx




var FDA = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 78 32",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_16673_82388)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.997 31.617H.477V.431h30.938c13.57 0 15.711 12.191 15.711 12.191L54.741.432h7.98l14.586 23.645-4.57 7.54H53.506v-3.762h21.512L58.722.43S47.983 19.117 45.678 22.758c-2.306 3.64-6.636 8.858-14.054 8.858H20.135V13.05h3.64v14.804h8.373c3.703 0 11.65-3.155 11.65-12.074 0-8.918-8.495-11.71-11.286-11.71H3.996V31.619Zm1.213 0V18.392H18.8v3.64H8.85v9.587H5.21ZM18.8 16.814v-3.762H8.85v-3.99h22.896c3.433 0 7.077 2.776 7.077 6.841s-3.684 6.856-6.31 6.856h-3.57v-9.707h-3.761V26.4h7.33c4.644 0 10.012-4.03 10.012-10.375 0-6.285-4.882-10.618-10.72-10.618H5.211v11.406H18.8Zm23.237 14.803L58.722 4.073 72.434 26.4H53.505v-3.64h12.256l-7.038-11.468-11.588 20.326H42.037Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_16673_82388",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "currentColor",
                        d: "M0 0h77.643v32H0z"
                    })
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/models/pim/attributes.ts
var pim_attributes = __webpack_require__(74822);
// EXTERNAL MODULE: ./src/modules/products/hooks/useProductAttributes.ts
var useProductAttributes = __webpack_require__(50999);
;// CONCATENATED MODULE: ./src/components/icons/FDARegistered.tsx




var FDARegistered = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 240 152",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
            width: "240",
            height: "152",
            xlinkHref: "data:image/png;base64,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"
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/FDACleared.tsx




var FDACleared = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 245 151",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
            width: "245",
            height: "151",
            xlinkHref: "data:image/png;base64,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"
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageShowcase/ProductPageShowcaseDetails.tsx

function ProductPageShowcaseDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  max-width: 410px;\n  color: ",
        ";\n"
    ]);
    ProductPageShowcaseDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageShowcaseDetails_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 24px 0;\n"
    ]);
    ProductPageShowcaseDetails_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageShowcaseDetails_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-weight: 500;\n  text-transform: uppercase;\n  color: ",
        ";\n\n  margin-bottom: 16px;\n"
    ]);
    ProductPageShowcaseDetails_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductPageShowcaseDetails_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin-top: 16px;\n"
    ]);
    ProductPageShowcaseDetails_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var ProductPageShowcaseDetails_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageShowcaseDetails__Container",
    componentId: "sc-e4b7b8b1-0"
})(ProductPageShowcaseDetails_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var Description = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).withConfig({
    displayName: "ProductPageShowcaseDetails__Description",
    componentId: "sc-e4b7b8b1-1"
})(ProductPageShowcaseDetails_templateObject1());
var Highlight = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).attrs({
    as: "span"
}).withConfig({
    displayName: "ProductPageShowcaseDetails__Highlight",
    componentId: "sc-e4b7b8b1-2"
})(ProductPageShowcaseDetails_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var IconContainer = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ProductPageShowcaseDetails__IconContainer",
    componentId: "sc-e4b7b8b1-3"
})(ProductPageShowcaseDetails_templateObject3());
var fdaIconMap = {
    fda: /*#__PURE__*/ (0,jsx_runtime.jsx)(FDA, {
        width: 78
    }),
    "fda-registered": /*#__PURE__*/ (0,jsx_runtime.jsx)(FDARegistered, {
        width: 78
    }),
    "fda-cleared": /*#__PURE__*/ (0,jsx_runtime.jsx)(FDACleared, {
        width: 78
    })
};
var ProductPageShowcaseDetails = function(param) {
    var _product = param.product, children = param.children;
    var product = (0,useTranslateItem/* useTranslateItem */.L)(_product);
    var getProductAttribute = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes).getProductAttribute;
    var description = product.description_long || product.description_short;
    var fdaIcon = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.FdaIcon */.c.FdaIcon));
    var _code, ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageShowcaseDetails_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* Heading */.X, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: product.name
                    }),
                    product.tagline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                        children: product.tagline
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description, {
                children: [
                    product.function && /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight, {
                        children: product.function
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: description
                    }),
                    !!fdaIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                        children: (ref = fdaIconMap[(_code = fdaIcon.code) !== null && _code !== void 0 ? _code : ""]) !== null && ref !== void 0 ? ref : fdaIconMap.fda
                    })
                ]
            }),
            children
        ]
    });
};

// EXTERNAL MODULE: ./vendor/mods/styled-components/index.tsx
var styled_components = __webpack_require__(10395);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var react_t7e_lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/components/icons/MailDefault.tsx
var MailDefault = __webpack_require__(61198);
// EXTERNAL MODULE: ./src/components/common/DispatchOnClick.tsx
var DispatchOnClick = __webpack_require__(94565);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageShowcase/index.tsx


function ProductPageShowcase_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n"
    ]);
    ProductPageShowcase_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageShowcase_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 0;\n  background: ",
        ";\n\n  ",
        " {\n    padding: 56px 0;\n  }\n"
    ]);
    ProductPageShowcase_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageShowcase_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n\n  ",
        " {\n    flex-direction: row;\n    gap: 120px;\n  }\n"
    ]);
    ProductPageShowcase_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var StyledButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "ProductPageShowcase__StyledButton",
    componentId: "sc-fb0e7b81-0"
})(ProductPageShowcase_templateObject());
var ProductPageShowcase_Container = styled_components_browser_esm["default"].header.withConfig({
    displayName: "ProductPageShowcase__Container",
    componentId: "sc-fb0e7b81-1"
})(ProductPageShowcase_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ContentContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "ProductPageShowcase__ContentContainer",
    componentId: "sc-fb0e7b81-2"
})(ProductPageShowcase_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageShowcase = function(param) {
    var product = param.product, children = param.children;
    var _ = (0,react_t7e_lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcase_Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcaseGallery, (0,_object_spread/* default */.Z)({}, product)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageShowcaseDetails, {
                        product: product,
                        children: [
                            children,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DispatchOnClick/* DispatchOnClick */.Q, {
                                type: "modalOpen",
                                payload: {
                                    kind: "contact"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                    icon: MailDefault/* MailDefault */.X,
                                    variant: "secondary",
                                    children: _(" Contact us")
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageHowItWorks/ProductPageHowItWorksItem.tsx

function ProductPageHowItWorksItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.3;\n  text-transform: uppercase;\n  color: ",
        ";\n  margin-top: 16px;\n  & + p {\n    margin-top: 12px;\n  }\n"
    ]);
    ProductPageHowItWorksItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageHowItWorksItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 335px;\n\n  ",
        " {\n    width: 426px;\n    height: 516px;\n    margin-bottom: 16px;\n  }\n"
    ]);
    ProductPageHowItWorksItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageHowItWorksItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"
    ]);
    ProductPageHowItWorksItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductPageHowItWorksItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 480px;\n  margin: 0 auto 0 0;\n  ",
        " {\n    margin: 0 0 0 auto;\n  }\n"
    ]);
    ProductPageHowItWorksItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductPageHowItWorksItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      flex-direction: row-reverse;\n      max-width: 1120px;\n      ",
        " {\n        width: 516px;\n        height: 595px;\n        margin-top: -78px;\n      }\n      ",
        " {\n        height: 725px;\n      }\n    "
    ]);
    ProductPageHowItWorksItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var Name = styled_components_browser_esm["default"].h4.withConfig({
    displayName: "ProductPageHowItWorksItem__Name",
    componentId: "sc-d0c467dd-0"
})(ProductPageHowItWorksItem_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageHowItWorksItem__ImageContainer",
    componentId: "sc-d0c467dd-1"
})(ProductPageHowItWorksItem_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ImageInnerContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageHowItWorksItem__ImageInnerContainer",
    componentId: "sc-d0c467dd-2"
})(ProductPageHowItWorksItem_templateObject2());
var ProductPageHowItWorksItem_ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageHowItWorksItem__ContentContainer",
    componentId: "sc-d0c467dd-3"
})(ProductPageHowItWorksItem_templateObject3(), theme/* dirRTL */.gX);
var ProductPageHowItWorksItem_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageHowItWorksItem__Container",
    componentId: "sc-d0c467dd-4"
})(_templateObject5(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, (0,casePathEmptyString/* casePathEmptyString */.Q)("$singular")((0,styled_components_browser_esm.css)(ProductPageHowItWorksItem_templateObject4(), ImageContainer, ImageInnerContainer)));
var ProductPageHowItWorksItem = function(param) {
    var title = param.title, description = param.description, image = param.image, singular = param.singular;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageHowItWorksItem_Container, {
        $singular: singular,
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageInnerContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                        src: image.directus_files_id.id,
                        layout: "fill",
                        objectFit: "cover",
                        sizes: "100vw"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageHowItWorksItem_ContentContainer, {
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: translateFn(title).value
                        })
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: translateFn(description).value
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/modules/products/hooks/useTitlesDictionary.ts
var useTitlesDictionary = __webpack_require__(76249);
// EXTERNAL MODULE: ./src/models/pim/dictionaries.ts
var dictionaries = __webpack_require__(56987);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageHowItWorks/index.tsx



function ProductPageHowItWorks_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: 48px;\n\n  ",
        " {\n    gap: 110px;\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    ProductPageHowItWorks_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageHowItWorks_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        margin-top: 16px;\n      }\n      ",
        " {\n        grid-template-columns: 1fr;\n      }\n    "
    ]);
    ProductPageHowItWorks_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageHowItWorks_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 32px 0;\n  background: ",
        ";\n\n  ",
        " {\n    padding: 56px 0;\n\n    ",
        "\n  }\n"
    ]);
    ProductPageHowItWorks_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


















var ProductPageHowItWorks_ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageHowItWorks__ContentContainer",
    componentId: "sc-b4775e5-0"
})(ProductPageHowItWorks_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageHowItWorks_Container = styled_components_browser_esm["default"].section.withConfig({
    displayName: "ProductPageHowItWorks__Container",
    componentId: "sc-b4775e5-1"
})(ProductPageHowItWorks_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, (0,casePathEmptyString/* casePathEmptyString */.Q)("$singular")((0,styled_components_browser_esm.css)(ProductPageHowItWorks_templateObject1(), ConstraintContainer/* ConstraintContainer */.a, ProductPageHowItWorks_ContentContainer)));
var ProductPageHowItWorks = function(product) {
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var ref = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes), getProductAttribute = ref.getProductAttribute, getMultipleProductAttributes = ref.getMultipleProductAttributes;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTitlesDictionary/* useTitlesDictionary */.L)(dictionaries/* DictionaryTitlesCode.HowItWorks */.v.HowItWorks), 1), title = ref1[0];
    var subtitle = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.HowItWorksSubtitle */.c.HowItWorksSubtitle));
    var items = (0,react.useMemo)(function() {
        return getMultipleProductAttributes(pim_attributes/* ProductAttributeCode.HowItWorksGroup */.c.HowItWorksGroup).map(function(attributes) {
            return {
                title: (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.HowItWorksGroupTitle */.c.HowItWorksGroupTitle, attributes)),
                description: (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.HowItWorksGroupText */.c.HowItWorksGroupText, attributes)),
                image: (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCollection.ImagesValues */.xi.ImagesValues, attributes))
            };
        });
    }, [
        getMultipleProductAttributes,
        getProductAttribute
    ]);
    if (items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageHowItWorks_Container, {
            $singular: items.length === 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* Heading */.X, {
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: title.value
                            }),
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                                children: translateFn(subtitle).value
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageHowItWorks_ContentContainer, {
                        children: items.map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageHowItWorksItem, (0,_object_spread/* default */.Z)({
                                singular: items.length === 1
                            }, item), i);
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageCrossSell/ProductPageRelatedItem.tsx

function ProductPageRelatedItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n  padding: 40px 24px;\n\n  width: 250px;\n  height: 370px;\n\n  background: ",
        ";\n  border: 2px solid transparent;\n  transition: 0.35s;\n\n  &:hover {\n    border-color: ",
        ";\n  }\n"
    ]);
    ProductPageRelatedItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageRelatedItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n  text-align: center;\n  margin-bottom: 8px;\n  margin-top: auto;\n\n  color: ",
        ";\n"
    ]);
    ProductPageRelatedItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageRelatedItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 200px;\n  height: 220px;\n  object-fit: contain;\n"
    ]);
    ProductPageRelatedItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var ProductPageRelatedItem_Container = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ProductPageRelatedItem__Container",
    componentId: "sc-ce793e9b-0"
})(ProductPageRelatedItem_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, function(param) {
    var theme = param.theme;
    return theme.buttons.default.primary.hover.accent;
});
var ProductPageRelatedItem_Name = styled_components_browser_esm["default"].h5.withConfig({
    displayName: "ProductPageRelatedItem__Name",
    componentId: "sc-ce793e9b-1"
})(ProductPageRelatedItem_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var ProductPageRelatedItem_ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageRelatedItem__ImageContainer",
    componentId: "sc-ce793e9b-2"
})(ProductPageRelatedItem_templateObject2());
var ProductPageRelatedItem = function(_item) {
    var item = (0,useTranslateItem/* useTranslateItem */.L)(_item);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
        href: route/* route.products */.BC.products().page(item),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageRelatedItem_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageRelatedItem_ImageContainer, {
                    children: item.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                        src: item.image.id,
                        width: 200,
                        height: 220,
                        objectFit: "contain",
                        sizes: "100vw"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageRelatedItem_Name, {
                    children: item.name
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/Swipers/ContentSwiper.tsx
var ContentSwiper = __webpack_require__(77314);
// EXTERNAL MODULE: ./src/modules/materials/components/ShowcasePage/common.tsx
var common = __webpack_require__(52178);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageCrossSell/index.tsx




function ProductPageCrossSell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 32px 0;\n  overflow: hidden;\n  background: #f6f6f6;\n\n  ",
        " {\n    padding: 56px 0;\n  }\n"
    ]);
    ProductPageCrossSell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageCrossSell_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-start;\n\n  &&& {\n    ",
        " {\n      top: 50%;\n      transform: translateY(-50%);\n      margin: 0;\n      display: flex !important;\n    }\n  }\n\n  .swiper-wrapper {\n    gap: 20px;\n  }\n  .swiper-slide {\n    width: min-content;\n  }\n"
    ]);
    ProductPageCrossSell_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var ProductPageCrossSell_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageCrossSell__Container",
    componentId: "sc-a8ea092a-0"
})(ProductPageCrossSell_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageCrossSell_SwiperContainer = (0,styled_components_browser_esm["default"])(ContentSwiper/* ContentSwiper */.o).withConfig({
    displayName: "ProductPageCrossSell__SwiperContainer",
    componentId: "sc-a8ea092a-1"
})(ProductPageCrossSell_templateObject1(), common/* NavigationButton */.W);
var _obj;
var categoryTitleMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, pim/* ProductCategoryCode.Cosmeceuticals */.qv.Cosmeceuticals, dictionaries/* DictionaryTitlesCode.CosmeceuticalsCrossSellingTitle */.v.CosmeceuticalsCrossSellingTitle), (0,_define_property/* default */.Z)(_obj, pim/* ProductCategoryCode.Devices */.qv.Devices, dictionaries/* DictionaryTitlesCode.DevicesCrossSellingTitle */.v.DevicesCrossSellingTitle), (0,_define_property/* default */.Z)(_obj, pim/* ProductCategoryCode.Fillers */.qv.Fillers, dictionaries/* DictionaryTitlesCode.FillersCrossSellingTitle */.v.FillersCrossSellingTitle), _obj);
var ProductPageCrossSell = function(product) {
    var ref;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var getProductAttribute = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes).getProductAttribute;
    var category = (0,pim/* getProductCategory */.dB)(product);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTitlesDictionary/* useTitlesDictionary */.L)(categoryTitleMap[category]), 1), dictionaryTitle = ref1[0];
    var ref2;
    var title = (ref2 = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.CrossSellingTitle */.c.CrossSellingTitle))) !== null && ref2 !== void 0 ? ref2 : dictionaryTitle;
    var items = product.cross_sell.map(function(p) {
        return p.related_products_id;
    }).filter(Boolean);
    if (items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageCrossSell_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: (ref = translateFn(title)) === null || ref === void 0 ? void 0 : ref.value
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageCrossSell_SwiperContainer, {
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageRelatedItem, (0,_object_spread/* default */.Z)({}, item))
                        }, item.code + index);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/modules/products/components/ProductPage/ProductPageBenefitsSection.tsx
var ProductPageBenefitsSection = __webpack_require__(35361);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(17573);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageShowcase/ProductPageShowcaseAttribute.tsx





function ProductPageShowcaseAttribute_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0;\n  width: 100%;\n\n  color: ",
        ";\n  border-bottom: 1rpx solid\n    ",
        ";\n"
    ]);
    ProductPageShowcaseAttribute_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageShowcaseAttribute_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  text-transform: uppercase;\n"
    ]);
    ProductPageShowcaseAttribute_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageShowcaseAttribute_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  em {\n    display: block;\n    margin-top: 8px;\n  }\n"
    ]);
    ProductPageShowcaseAttribute_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var ProductPageShowcaseAttribute_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageShowcaseAttribute__Container",
    componentId: "sc-74d16067-0"
})(ProductPageShowcaseAttribute_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.6, theme.text.palette.secondary);
});
var Label = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).attrs({
    as: "span"
}).withConfig({
    displayName: "ProductPageShowcaseAttribute__Label",
    componentId: "sc-74d16067-1"
})(ProductPageShowcaseAttribute_templateObject1());
var ProductPageShowcaseAttribute_Description = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).withConfig({
    displayName: "ProductPageShowcaseAttribute__Description",
    componentId: "sc-74d16067-2"
})(ProductPageShowcaseAttribute_templateObject2());
var ProductPageShowcaseAttribute = function(_param) {
    var product = _param.product, label = _param.label, labelCode = _param.labelCode, description = _param.description, descriptionCode = _param.descriptionCode, props = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "label",
        "labelCode",
        "description",
        "descriptionCode"
    ]);
    var ref;
    var _ = (0,react_t7e_lib.useTranslate)()._;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var getProductAttribute = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes).getProductAttribute;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTitlesDictionary/* useTitlesDictionary */.L)(labelCode), 1), dictionaryLabel = ref1[0];
    var descriptionAttribute = getProductAttribute(descriptionCode);
    var applicationTimes = (ref = getProductAttribute(pim_attributes/* ProductAttributeCode.ApplicationTime */.c.ApplicationTime)) === null || ref === void 0 ? void 0 : ref.map(translateFn);
    var labelToDisplay = label !== null && label !== void 0 ? label : dictionaryLabel === null || dictionaryLabel === void 0 ? void 0 : dictionaryLabel.value;
    var descriptionToDisplay = description !== null && description !== void 0 ? description : descriptionAttribute === null || descriptionAttribute === void 0 ? void 0 : descriptionAttribute.map(translateFn).map(function(d) {
        return d.value;
    }).join(", ");
    if (!labelToDisplay || !label && !descriptionToDisplay) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageShowcaseAttribute_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                    children: labelToDisplay
                })
            }),
            descriptionToDisplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageShowcaseAttribute_Description, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: descriptionToDisplay
                    }),
                    pim_attributes/* ProductAttributeCode.Application */.c.Application === descriptionCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: applicationTimes === null || applicationTimes === void 0 ? void 0 : applicationTimes.map(function(d) {
                            return d.value;
                        }).join(" ".concat(_("and"), " "))
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/modules/products/components/ProductPage/ProductPageLegalMentions.tsx + 2 modules
var ProductPageLegalMentions = __webpack_require__(42768);
// EXTERNAL MODULE: ./src/modules/products/components/ProductPage/ProductPageResultsSection.tsx
var ProductPageResultsSection = __webpack_require__(74762);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageTechnicalFeatures/TechnicalFeatureItem.tsx

function TechnicalFeatureItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  ",
        " {\n    width: 430px;\n  }\n"
    ]);
    TechnicalFeatureItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TechnicalFeatureItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 335px;\n  height: 335px;\n  margin-bottom: 32px;\n"
    ]);
    TechnicalFeatureItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TechnicalFeatureItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  text-transform: uppercase;\n  margin: 0 0 16px;\n"
    ]);
    TechnicalFeatureItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var TechnicalFeatureItem_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TechnicalFeatureItem__Container",
    componentId: "sc-7054caa2-0"
})(TechnicalFeatureItem_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var TechnicalFeatureItem_ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TechnicalFeatureItem__ImageContainer",
    componentId: "sc-7054caa2-1"
})(TechnicalFeatureItem_templateObject1());
var TechnicalFeatureItem_Heading = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "TechnicalFeatureItem__Heading",
    componentId: "sc-7054caa2-2"
})(TechnicalFeatureItem_templateObject2());
var TechnicalFeatureItem = function(param) {
    var title = param.title, description = param.description, image = param.image;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TechnicalFeatureItem_Container, {
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalFeatureItem_ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                    src: image.directus_files_id.id,
                    layout: "fill",
                    objectFit: "contain",
                    objectPosition: "0 50%",
                    sizes: "100vw"
                })
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalFeatureItem_Heading, {
                children: translateFn(title).value
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                children: translateFn(description).value
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageTechnicalFeatures/index.tsx



function ProductPageTechnicalFeatures_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 32px 0;\n  overflow: hidden;\n\n  ",
        " {\n    padding: 56px 0 86px;\n  }\n"
    ]);
    ProductPageTechnicalFeatures_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageTechnicalFeatures_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-start;\n\n  &&& {\n    ",
        " {\n      top: 50%;\n      transform: translateY(-50%);\n      margin: 0;\n      display: flex !important;\n    }\n  }\n\n  .swiper-wrapper {\n    gap: 100px;\n  }\n\n  .swiper-slide {\n    width: min-content;\n  }\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    ProductPageTechnicalFeatures_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageTechnicalFeatures_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    ProductPageTechnicalFeatures_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductPageTechnicalFeatures_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 32px;\n  max-width: 870px;\n\n  ",
        " {\n    margin-bottom: 48px;\n  }\n"
    ]);
    ProductPageTechnicalFeatures_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


















var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "ProductPageTechnicalFeatures__Section",
    componentId: "sc-e2f0b0a3-0"
})(ProductPageTechnicalFeatures_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageTechnicalFeatures_SwiperContainer = (0,styled_components_browser_esm["default"])(ContentSwiper/* ContentSwiper */.o).withConfig({
    displayName: "ProductPageTechnicalFeatures__SwiperContainer",
    componentId: "sc-e2f0b0a3-1"
})(ProductPageTechnicalFeatures_templateObject1(), common/* NavigationButton */.W, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var MobileContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageTechnicalFeatures__MobileContainer",
    componentId: "sc-e2f0b0a3-2"
})(ProductPageTechnicalFeatures_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageTechnicalFeatures_Description = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).withConfig({
    displayName: "ProductPageTechnicalFeatures__Description",
    componentId: "sc-e2f0b0a3-3"
})(ProductPageTechnicalFeatures_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageTechnicalFeatures = function(product) {
    var ref;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var ref1 = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes), getProductAttribute = ref1.getProductAttribute, getMultipleProductAttributes = ref1.getMultipleProductAttributes;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useTitlesDictionary/* useTitlesDictionary */.L)(dictionaries/* DictionaryTitlesCode.TechnicalFeatures */.v.TechnicalFeatures), 1), title = ref2[0];
    var description = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.TechnicalFeaturesAndHandpieceText */.c.TechnicalFeaturesAndHandpieceText));
    var items = (0,react.useMemo)(function() {
        return getMultipleProductAttributes(pim_attributes/* ProductAttributeCode.TechnicalFeaturesAndHandpieceGroup */.c.TechnicalFeaturesAndHandpieceGroup).map(function(attributes) {
            return {
                title: (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.TechnicalFeaturesAndHandpieceGroupTitle */.c.TechnicalFeaturesAndHandpieceGroupTitle, attributes)),
                description: (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.TechnicalFeaturesAndHandpieceGroupText */.c.TechnicalFeaturesAndHandpieceGroupText, attributes)),
                image: (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.TechnicalFeaturesAndHandpieceGroupImage */.c.TechnicalFeaturesAndHandpieceGroupImage, attributes))
            };
        });
    }, [
        getProductAttribute,
        getMultipleProductAttributes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: (ref = translateFn(title)) === null || ref === void 0 ? void 0 : ref.value
                    })
                }),
                description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageTechnicalFeatures_Description, {
                        children: translateFn(description).value
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageTechnicalFeatures_SwiperContainer, {
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalFeatureItem, (0,_object_spread/* default */.Z)({}, item))
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileContainer, {
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalFeatureItem, (0,_object_spread/* default */.Z)({}, item), index);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/icons/File.tsx
var File = __webpack_require__(19838);
// EXTERNAL MODULE: ./src/components/icons/Download.tsx
var Download = __webpack_require__(84670);
// EXTERNAL MODULE: ./node_modules/pretty-bytes/index.js
var pretty_bytes = __webpack_require__(54748);
// EXTERNAL MODULE: ./src/services/pim/index.ts
var services_pim = __webpack_require__(57539);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageDownloads/ProductPageDownloadsItem.tsx

function ProductPageDownloadsItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border-bottom: 1rpx solid ",
        ";\n  padding: 16px 0;\n\n  ",
        " {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n"
    ]);
    ProductPageDownloadsItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageDownloadsItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"
    ]);
    ProductPageDownloadsItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageDownloadsItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  ",
        " {\n    flex-direction: row;\n    align-items: baseline;\n    gap: 12px;\n  }\n"
    ]);
    ProductPageDownloadsItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductPageDownloadsItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n"
    ]);
    ProductPageDownloadsItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductPageDownloadsItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n  font-weight: 300;\n"
    ]);
    ProductPageDownloadsItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProductPageDownloadsItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 144px !important;\n  max-width: 144px !important;\n"
    ]);
    ProductPageDownloadsItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var ProductPageDownloadsItem_Container = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ProductPageDownloadsItem__Container",
    componentId: "sc-347acddb-0"
})(ProductPageDownloadsItem_templateObject(), function(param) {
    var theme = param.theme;
    return theme.skeleton.base;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var FileContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageDownloadsItem__FileContainer",
    componentId: "sc-347acddb-1"
})(ProductPageDownloadsItem_templateObject1());
var FileDetails = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageDownloadsItem__FileDetails",
    componentId: "sc-347acddb-2"
})(ProductPageDownloadsItem_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageDownloadsItem_Name = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageDownloadsItem__Name",
    componentId: "sc-347acddb-3"
})(ProductPageDownloadsItem_templateObject3());
var Size = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageDownloadsItem__Size",
    componentId: "sc-347acddb-4"
})(ProductPageDownloadsItem_templateObject4());
var ProductPageDownloadsItem_StyledButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "ProductPageDownloadsItem__StyledButton",
    componentId: "sc-347acddb-5"
})(ProductPageDownloadsItem_templateObject5());
var ProductPageDownloadsItem = function(param) {
    var id = param.id, filesize = param.filesize, filename_download = param.filename_download;
    var _ = (0,react_t7e_lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageDownloadsItem_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(File/* File */.$, {
                        size: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileDetails, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageDownloadsItem_Name, {
                                children: filename_download
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Size, {
                                children: (0,pretty_bytes/* default */.Z)(Number(filesize))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageDownloadsItem_StyledButton, {
                forwardedAs: "a",
                icon: Download/* Download */.U,
                href: (0,services_pim/* getPimFileAssetUrl */.hV)(id) + "?download",
                children: _("DOWNLOAD")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageDownloads/index.tsx



function ProductPageDownloads_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 50px 0 56px;\n  background: ",
        ";\n\n  ",
        " {\n    padding: 80px 0 160px;\n  }\n"
    ]);
    ProductPageDownloads_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var ProductPageDownloads_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "ProductPageDownloads__Section",
    componentId: "sc-88da155c-0"
})(ProductPageDownloads_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageDownloads = function(product) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTitlesDictionary/* useTitlesDictionary */.L)(dictionaries/* DictionaryTitlesCode.Downloads */.v.Downloads), 1), title = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTitlesDictionary/* useTitlesDictionary */.L)(dictionaries/* DictionaryTitlesCode.DownloadsSubtitle */.v.DownloadsSubtitle), 1), subtitle = ref1[0];
    var getProductAttribute = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes).getProductAttribute;
    var ref2;
    var files = (0,react.useMemo)(function() {
        var ref;
        return (ref2 = (ref = getProductAttribute(pim_attributes/* ProductAttributeCode.Leaflet */.c.Leaflet)) === null || ref === void 0 ? void 0 : ref.map(function(attribute) {
            return attribute.directus_files_id;
        })) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        getProductAttribute
    ]);
    if (files.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageDownloads_Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* Heading */.X, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: title.value
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: subtitle.value
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: files.map(function(file) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageDownloadsItem, (0,_object_spread/* default */.Z)({}, file), file.id);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/modules/products/components/ProductPage/ProductPageSctSection/index.tsx + 1 modules
var ProductPageSctSection = __webpack_require__(11287);
// EXTERNAL MODULE: ./src/modules/products/components/ProductPage/ProductPageSEO.tsx
var ProductPageSEO = __webpack_require__(85170);
;// CONCATENATED MODULE: ./src/modules/products/templates/ProductPageDevicesTemplate.tsx

















var ProductPageDevicesTemplate = function(product) {
    var ref;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var getProductAttribute = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes).getProductAttribute;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageSEO/* ProductPageSEO */.x, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcase, {
                product: product,
                children: (ref = getProductAttribute(pim_attributes/* ProductAttributeCode.TreatmentEssentials */.c.TreatmentEssentials)) === null || ref === void 0 ? void 0 : ref.map(translateFn).map(function(attr, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcaseAttribute, {
                        product: product,
                        label: attr.value
                    }, attr.value + index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageBenefitsSection/* ProductPageBenefitsSection */.s, {
                product: product,
                textCode: pim_attributes/* ProductAttributeCode.KeyBenefitsText */.c.KeyBenefitsText,
                titleCode: pim_attributes/* ProductAttributeCode.KeyBenefitsTitle */.c.KeyBenefitsTitle,
                dictionaryTitleCode: dictionaries/* DictionaryTitlesCode.KeyBenefits */.v.KeyBenefits
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageHowItWorks, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageResultsSection/* ProductPageResultsSection */.n, {
                product: product,
                dictionaryTitleCode: dictionaries/* DictionaryTitlesCode.Results */.v.Results,
                textCode: pim_attributes/* ProductAttributeCode.ResultsText */.c.ResultsText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageTechnicalFeatures, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageDownloads, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageSctSection/* ProductPageSctSection */.Z, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageCrossSell, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageLegalMentions/* ProductPageLegalMentions */.n, (0,_object_spread/* default */.Z)({}, product))
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageFeaturesSection.tsx


function ProductPageFeaturesSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 32px 0;\n  ",
        " {\n    padding: 56px 0 78px;\n  }\n"
    ]);
    ProductPageFeaturesSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageFeaturesSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column-reverse;\n\n  ",
        " {\n    flex-direction: row;\n    gap: 110px;\n  }\n"
    ]);
    ProductPageFeaturesSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductPageFeaturesSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  max-width: 427px;\n  height: 404px;\n  ",
        " {\n    height: 601px;\n  }\n"
    ]);
    ProductPageFeaturesSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductPageFeaturesSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 440px;\n"
    ]);
    ProductPageFeaturesSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductPageFeaturesSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  & > span {\n    font-weight: 700;\n    font-size: 18px;\n  }\n  & > p {\n    font-size: 16px;\n  }\n  ",
        " {\n    padding: 12px 0;\n  }\n"
    ]);
    ProductPageFeaturesSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}














var ProductPageFeaturesSection_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "ProductPageFeaturesSection__Section",
    componentId: "sc-e634baf5-0"
})(ProductPageFeaturesSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageFeaturesSection_ContentContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "ProductPageFeaturesSection__ContentContainer",
    componentId: "sc-e634baf5-1"
})(ProductPageFeaturesSection_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageFeaturesSection_ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageFeaturesSection__ImageContainer",
    componentId: "sc-e634baf5-2"
})(ProductPageFeaturesSection_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var AttributesContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductPageFeaturesSection__AttributesContainer",
    componentId: "sc-e634baf5-3"
})(ProductPageFeaturesSection_templateObject3());
var Attribute = (0,styled_components_browser_esm["default"])(ProductPageShowcaseAttribute).withConfig({
    displayName: "ProductPageFeaturesSection__Attribute",
    componentId: "sc-e634baf5-4"
})(ProductPageFeaturesSection_templateObject4(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ProductPageFeaturesSection = function(product) {
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var getProductAttribute = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes).getProductAttribute;
    var image = (0,lodash.head)(getProductAttribute(pim_attributes/* ProductAttributeCode.FeaturesImage */.c.FeaturesImage));
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTitlesDictionary/* useTitlesDictionary */.L)(dictionaries/* DictionaryTitlesCode.ProductFeatures */.v.ProductFeatures), 1), title = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageFeaturesSection_Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageFeaturesSection_ContentContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttributesContainer, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: translateFn(title).value
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attribute, {
                            product: product,
                            labelCode: dictionaries/* DictionaryTitlesCode.ExtrusionForce */.v.ExtrusionForce,
                            descriptionCode: pim_attributes/* ProductAttributeCode.ExtrusionForce */.c.ExtrusionForce
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attribute, {
                            product: product,
                            labelCode: dictionaries/* DictionaryTitlesCode.Duration */.v.Duration,
                            descriptionCode: pim_attributes/* ProductAttributeCode.Duration */.c.Duration
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attribute, {
                            product: product,
                            labelCode: dictionaries/* DictionaryTitlesCode.InjectionPlace */.v.InjectionPlace,
                            descriptionCode: pim_attributes/* ProductAttributeCode.InjectionPlace */.c.InjectionPlace
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Attribute, {
                            product: product,
                            labelCode: dictionaries/* DictionaryTitlesCode.InjectionTool */.v.InjectionTool,
                            descriptionCode: pim_attributes/* ProductAttributeCode.InjectionTool */.c.InjectionTool
                        })
                    ]
                }),
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageFeaturesSection_ImageContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                        src: image.directus_files_id.id,
                        layout: "fill",
                        objectFit: "cover",
                        sizes: "100vw"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/products/templates/ProductPageFillersTemplate.tsx












var ProductPageFillersTemplate = function(product) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageSEO/* ProductPageSEO */.x, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageShowcase, {
                product: product,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcaseAttribute, {
                        product: product,
                        labelCode: dictionaries/* DictionaryTitlesCode.HaConcentration */.v.HaConcentration,
                        descriptionCode: pim_attributes/* ProductAttributeCode.HaConcentration */.c.HaConcentration
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcaseAttribute, {
                        product: product,
                        labelCode: dictionaries/* DictionaryTitlesCode.Contains */.v.Contains,
                        descriptionCode: pim_attributes/* ProductAttributeCode.Ingredients */.c.Ingredients
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcaseAttribute, {
                        product: product,
                        labelCode: dictionaries/* DictionaryTitlesCode.AreaOfInjection */.v.AreaOfInjection,
                        descriptionCode: pim_attributes/* ProductAttributeCode.AreaOfInjection */.c.AreaOfInjection
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageFeaturesSection, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageDownloads, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageSctSection/* ProductPageSctSection */.Z, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageCrossSell, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageLegalMentions/* ProductPageLegalMentions */.n, (0,_object_spread/* default */.Z)({}, product))
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageDescriptionSection.tsx


function ProductPageDescriptionSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 32px 0;\n  ",
        " {\n    padding: 56px 0;\n  }\n"
    ]);
    ProductPageDescriptionSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductPageDescriptionSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  b,\n  strong {\n    font-size: 18px;\n  }\n"
    ]);
    ProductPageDescriptionSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var ProductPageDescriptionSection_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "ProductPageDescriptionSection__Section",
    componentId: "sc-f36a3806-0"
})(ProductPageDescriptionSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageDescriptionSection_Description = (0,styled_components_browser_esm["default"])(Text/* Paragraph */.n).withConfig({
    displayName: "ProductPageDescriptionSection__Description",
    componentId: "sc-f36a3806-1"
})(ProductPageDescriptionSection_templateObject1());
var ProductPageDescriptionSection = function(param) {
    var product = param.product, titleCode = param.titleCode, dictionaryTitleCode = param.dictionaryTitleCode, descriptionCode = param.descriptionCode;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var getProductAttribute = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes).getProductAttribute;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTitlesDictionary/* useTitlesDictionary */.L)(dictionaryTitleCode), 1), dictionaryTitle = ref[0];
    var ref1;
    var title = (ref1 = (0,lodash.head)(getProductAttribute(titleCode))) !== null && ref1 !== void 0 ? ref1 : dictionaryTitle;
    var description = (0,lodash.head)(getProductAttribute(descriptionCode));
    if (!description || !translateFn(description).value) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageDescriptionSection_Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: translateFn(title).value
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageDescriptionSection_Description, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: translateFn(description).value
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/StickyMenu/StickyMenuSection.tsx
var StickyMenuSection = __webpack_require__(226);
;// CONCATENATED MODULE: ./src/modules/products/components/ProductPage/ProductPageIngredientsListSection.tsx


function ProductPageIngredientsListSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0 48px;\n  background: ",
        ";\n\n  ",
        " {\n    padding: 16px 0 58px;\n  }\n"
    ]);
    ProductPageIngredientsListSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var ProductPageIngredientsListSection_Section = (0,styled_components_browser_esm["default"])(StickyMenuSection/* StickyMenuSection */.T).withConfig({
    displayName: "ProductPageIngredientsListSection__Section",
    componentId: "sc-cd967bab-0"
})(ProductPageIngredientsListSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProductPageIngredientsListSection = function(param) {
    var product = param.product, titleCode = param.titleCode, dictionaryTitleCode = param.dictionaryTitleCode, descriptionCode = param.descriptionCode;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var getProductAttribute = (0,useProductAttributes/* useProductAttributes */.g)(product.attributes).getProductAttribute;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTitlesDictionary/* useTitlesDictionary */.L)(dictionaryTitleCode), 1), dictionaryTitle = ref[0];
    var ref1;
    var title = (ref1 = (0,lodash.head)(getProductAttribute(titleCode))) !== null && ref1 !== void 0 ? ref1 : dictionaryTitle;
    var description = (0,lodash.head)(getProductAttribute(descriptionCode));
    if (!title || !description || !translateFn(description).value) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageIngredientsListSection_Section, {
        id: "ingredients",
        label: translateFn(title).value,
        threshold: 0.5,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* Heading */.X, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: translateFn(title).value
                    })
                }),
                description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Paragraph */.n, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: translateFn(description).value
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/products/templates/ProductPageCosmeceuticalsTemplate.tsx










// import { ProductPageSkincareRoutinesSection } from 'src/modules/products/components/ProductPage/ProductPageSkincareRoutinesSection';




var ProductPageCosmeceuticalsTemplate = function(product) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageSEO/* ProductPageSEO */.x, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductPageShowcase, {
                product: product,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcaseAttribute, {
                        product: product,
                        labelCode: dictionaries/* DictionaryTitlesCode.Volume */.v.Volume,
                        descriptionCode: pim_attributes/* ProductAttributeCode.Volume */.c.Volume
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcaseAttribute, {
                        product: product,
                        labelCode: dictionaries/* DictionaryTitlesCode.KeyActiveIngredients */.v.KeyActiveIngredients,
                        descriptionCode: pim_attributes/* ProductAttributeCode.KeyIngredients */.c.KeyIngredients
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcaseAttribute, {
                        product: product,
                        labelCode: dictionaries/* DictionaryTitlesCode.Application */.v.Application,
                        descriptionCode: pim_attributes/* ProductAttributeCode.Application */.c.Application
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageShowcaseAttribute, {
                        product: product,
                        labelCode: dictionaries/* DictionaryTitlesCode.BeautyTip */.v.BeautyTip,
                        descriptionCode: pim_attributes/* ProductAttributeCode.BeautyTip */.c.BeautyTip
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageBenefitsSection/* ProductPageBenefitsSection */.s, {
                product: product,
                textCode: pim_attributes/* ProductAttributeCode.KeyBenefitsText */.c.KeyBenefitsText,
                titleCode: pim_attributes/* ProductAttributeCode.KeyBenefitsTitle */.c.KeyBenefitsTitle,
                dictionaryTitleCode: dictionaries/* DictionaryTitlesCode.KeyBenefits */.v.KeyBenefits
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageBenefitsSection/* ProductPageBenefitsSection */.s, {
                product: product,
                textCode: pim_attributes/* ProductAttributeCode.AestheticIndicationText */.c.AestheticIndicationText,
                titleCode: pim_attributes/* ProductAttributeCode.AestheticIndicationTitle */.c.AestheticIndicationTitle,
                dictionaryTitleCode: dictionaries/* DictionaryTitlesCode.AestheticIndications */.v.AestheticIndications
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageIngredientsListSection, {
                product: product,
                dictionaryTitleCode: dictionaries/* DictionaryTitlesCode.IngredientsList */.v.IngredientsList,
                descriptionCode: pim_attributes/* ProductAttributeCode.Ingredients */.c.Ingredients
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageDescriptionSection, {
                product: product,
                dictionaryTitleCode: dictionaries/* DictionaryTitlesCode.ScienceBehind */.v.ScienceBehind,
                descriptionCode: pim_attributes/* ProductAttributeCode.IngredientsEffectivenessText */.c.IngredientsEffectivenessText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageDownloads, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageSctSection/* ProductPageSctSection */.Z, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageCrossSell, (0,_object_spread/* default */.Z)({}, product)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPageLegalMentions/* ProductPageLegalMentions */.n, (0,_object_spread/* default */.Z)({}, product))
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/products/[categoryOrCode]/[code].tsx









var _code_obj;
var productCategoryTemplateMap = (_code_obj = {}, (0,_define_property/* default */.Z)(_code_obj, pim/* ProductCategoryCode.Cosmeceuticals */.qv.Cosmeceuticals, ProductPageCosmeceuticalsTemplate), (0,_define_property/* default */.Z)(_code_obj, pim/* ProductCategoryCode.Devices */.qv.Devices, ProductPageDevicesTemplate), (0,_define_property/* default */.Z)(_code_obj, pim/* ProductCategoryCode.Fillers */.qv.Fillers, ProductPageFillersTemplate), _code_obj);
var ProductPage = function(param) {
    var product = param.product;
    var category = (0,pim/* getProductCategory */.dB)(product);
    var Renderer = (0,react.useMemo)(function() {
        return productCategoryTemplateMap[category];
    }, [
        category
    ]);
    if (Renderer) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Renderer, (0,_object_spread/* default */.Z)({}, product));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(not_found["default"], {});
};
var __N_SSP = true;
/* harmony default export */ var _code_ = (ProductPage);


/***/ }),

/***/ 54748:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ prettyBytes; }
/* harmony export */ });
const BYTE_UNITS = [
	'B',
	'kB',
	'MB',
	'GB',
	'TB',
	'PB',
	'EB',
	'ZB',
	'YB',
];

const BIBYTE_UNITS = [
	'B',
	'kiB',
	'MiB',
	'GiB',
	'TiB',
	'PiB',
	'EiB',
	'ZiB',
	'YiB',
];

const BIT_UNITS = [
	'b',
	'kbit',
	'Mbit',
	'Gbit',
	'Tbit',
	'Pbit',
	'Ebit',
	'Zbit',
	'Ybit',
];

const BIBIT_UNITS = [
	'b',
	'kibit',
	'Mibit',
	'Gibit',
	'Tibit',
	'Pibit',
	'Eibit',
	'Zibit',
	'Yibit',
];

/*
Formats the given number using `Number#toLocaleString`.
- If locale is a string, the value is expected to be a locale-key (for example: `de`).
- If locale is true, the system default locale is used for translation.
- If no value for locale is specified, the number is returned unmodified.
*/
const toLocaleString = (number, locale, options) => {
	let result = number;
	if (typeof locale === 'string' || Array.isArray(locale)) {
		result = number.toLocaleString(locale, options);
	} else if (locale === true || options !== undefined) {
		result = number.toLocaleString(undefined, options);
	}

	return result;
};

function prettyBytes(number, options) {
	if (!Number.isFinite(number)) {
		throw new TypeError(`Expected a finite number, got ${typeof number}: ${number}`);
	}

	options = {
		bits: false,
		binary: false,
		...options,
	};

	const UNITS = options.bits
		? (options.binary ? BIBIT_UNITS : BIT_UNITS)
		: (options.binary ? BIBYTE_UNITS : BYTE_UNITS);

	if (options.signed && number === 0) {
		return ` 0 ${UNITS[0]}`;
	}

	const isNegative = number < 0;
	const prefix = isNegative ? '-' : (options.signed ? '+' : '');

	if (isNegative) {
		number = -number;
	}

	let localeOptions;

	if (options.minimumFractionDigits !== undefined) {
		localeOptions = {minimumFractionDigits: options.minimumFractionDigits};
	}

	if (options.maximumFractionDigits !== undefined) {
		localeOptions = {maximumFractionDigits: options.maximumFractionDigits, ...localeOptions};
	}

	if (number < 1) {
		const numberString = toLocaleString(number, options.locale, localeOptions);
		return prefix + numberString + ' ' + UNITS[0];
	}

	const exponent = Math.min(Math.floor(options.binary ? Math.log(number) / Math.log(1024) : Math.log10(number) / 3), UNITS.length - 1);
	number /= (options.binary ? 1024 : 1000) ** exponent;

	if (!localeOptions) {
		number = number.toPrecision(3);
	}

	const numberString = toLocaleString(Number(number), options.locale, localeOptions);

	const unit = UNITS[exponent];

	return prefix + numberString + ' ' + unit;
}


/***/ })

}]);